import React from "react";
import {
  CountryPreviewFragment,
  CustomFieldSchemaFragment,
} from "__generated__/graphql";
import {
  CountryAutocompleteField,
  ICountryAutoCompleteFieldValue,
} from "common/fields/countryAutoCompleteField/CountryAutocompleteField";

interface ICustomCountriesFieldProps {
  value: CountryPreviewFragment[];
  setValue: (value: CountryPreviewFragment[]) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  touched?: boolean;
}
export const CustomCountriesField = ({
  value,
  setValue,
  schema,
  showLabel,
  labelledById,
  onKeyDown,
  errorMessage,
  touched,
}: ICustomCountriesFieldProps) => {
  const handleSetValue = (newValue: ICountryAutoCompleteFieldValue) => {
    if (Array.isArray(newValue)) {
      setValue(newValue);
    }
  };
  return (
    <CountryAutocompleteField
      value={value}
      setValue={handleSetValue}
      label={showLabel ? schema?.name : ""}
      labelledById={labelledById}
      multiple
      onKeyDown={onKeyDown}
      touched={touched}
      errorMessage={errorMessage}
    />
  );
};
